import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface ActiveOperation {
  id: string;
  status: string;
  processed_modules: number;
  total_modules: number;
  successful_modules: number;
  started_at: string;
}

export const useActiveQuizGeneration = () => {
  const [activeOperation, setActiveOperation] = useState<ActiveOperation | null>(null);

  useEffect(() => {
    checkActiveOperation();
  }, []);

  const checkActiveOperation = async () => {
    try {
      const { data } = await supabase
        .from('quiz_generation_operations')
        .select('*')
        .eq('status', 'in_progress')
        .order('started_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (data) {
        setActiveOperation(data as ActiveOperation);
        
        const progress = Math.round((data.processed_modules / data.total_modules) * 100);
        const elapsed = Math.floor((Date.now() - new Date(data.started_at).getTime()) / 1000 / 60);
        
        toast.info(
          `📊 Quiz generation in progress: ${data.processed_modules}/${data.total_modules} (${progress}%) - Started ${elapsed} min ago`,
          { duration: 10000 }
        );
      }
    } catch (error) {
      console.error('Failed to check active operations:', error);
    }
  };

  return { activeOperation, refetch: checkActiveOperation };
};
